import { h, Component } from 'preact';
import cx from 'classnames';
import Portal from 'preact-portal';
import { Subscription, Subject } from 'rxjs';
import Axios, { AxiosPromise } from 'axios';

import { debounce } from '../../../utils/debounce';
import { API_ENDPOINT } from '../../../../constants/api';
import { showToast } from '../../../utils/toast.service';
import { User } from '../../../../types/user.model';

export interface AutocompleteSearchProps {
  searchFunction?: Function; 
  // should be using this
  // but I'm making it a direct call for now

  searchUrl?: string;
  placeholder?: string;

  onResultSelected: Function;
}

export interface AutocompleteSearchState {
  searchResults?: User[];
  search?: string;
  isSearchResultsVisible?: boolean;
}

export class AutocompleteSearch extends Component<AutocompleteSearchProps, AutocompleteSearchState> {

  constructor(props: AutocompleteSearchProps) {
    super(props);

    this.setState({
      searchResults: [],
    })
  }

  onSearchInputChange = debounce((event) => {

    const searchTerm = event.target.value;

    if (searchTerm && searchTerm.length >= 2) {
      this.getSearchResults(searchTerm);
    } 
    
    this.setState({
      search: searchTerm
    });

  }, 500);

  getSearchResults(searchTerm?: string) {
    let params = {
      userSearch: searchTerm
    };

    const searchUrl: string = this.props.searchUrl ? this.props.searchUrl : 'supervisor';

    const axiosPromise = Axios.get(
      `${API_ENDPOINT}/${searchUrl}`,
      {
        params: params,
        withCredentials: true
      }
    );

    axiosPromise.then((response) => {
      const results = response.data.results;

      this.setState({
        searchResults: results,
        isSearchResultsVisible: true
      });
    }).catch(errResp => {
      let message = errResp.response.data.msg ? errResp.response.data.msg : null;
      
      showToast({
        title: 'Failed to retrieve search',
        message: message,
        duration: 3000
      });
    })

  }

  onResultClick = (result: User) => {
    const label = `${result.firstName} ${result.lastName}`;

    this.setState({
      search: label,
      searchResults: [],
      isSearchResultsVisible: false,
    })
    console.log('result', result)
    this.props.onResultSelected(result);
  }

  render(props: AutocompleteSearchProps, state: AutocompleteSearchState) {
    const result = (member, index) => {
      return <p onClick={this.onResultClick.bind(this, member)}> 
       { member.firstName } { member.lastName } <i>({ member.username })</i>
      </p>;
    }

    return (
      <div class="autocomplete-search">
        <input type="text"
          className={ cx('autocomplete-search__input form-control') } 
          
          placeholder={props.placeholder ? props.placeholder : 'Search by Supervisor'}
          value={state.search}
          onInput={this.onSearchInputChange.bind(this)}
        />
        <span class="autocomplete-search__icon">
          <i class="fas fa-search"></i>
        </span>
        <div className={cx('autocomplete-search__results', {active : state.isSearchResultsVisible})}>
          { this.state.searchResults.map((member, i) => result(member, i)) }
        </div>
      </div>
    )
  }

}